<template>
    <div class="field-table flex-1 flex flex-col  max-h-full max-w-full  min-h-full text-base-content">
        <!-- <SubHeader  
            class="mx-6" 
            :backButton="true"  
            :backRedirectionUrl="`/credit-packs?tab=summary`"
            :showOnlyCustomCrumbs="true"
        /> -->
        <div class="flex relative flex-1 flex-col flex-grow max-h-full max-w-full">
            <vue-good-table 
                :columns="columns" 
                :isLoading="loading" 
                :rows="rowsData" 
                :pagination-options="{ enabled: true, mode: 'records', dropdownAllowAll: false,}" 
                :totalRows="pageData.total_count"
                @on-page-change="onPageChange($event)"
                @on-per-page-change="onPageChange($event, true)"
            >
                <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field === 'unique_id'" class="flex gap-3 pl-3">
                        {{ props.row.unique_id}}
                    </div>
                     <div v-if="props.column.field == 'assignee'" class="flex justify-center">
                        {{props.row.assignee}}
                    </div>
                    <div v-if="props.column.field == 'limits_per_month'" class="flex justify-center">
                        {{props.row.limits_per_month}}
                    </div>
                    <div v-if="props.column.field == 'alloted'" class="flex justify-center">
                        {{props.row.alloted}} Days
                    </div>
                    <div v-if="props.column.field == 'balance'" class="flex justify-center">
                        {{ props.row.balance }}
                    </div>
                    <div v-if="props.column.field == 'expiry_date'" class="flex justify-center">
                        {{ props.row.expiry_date ? FormatDate(new Date(props.row.expiry_date)) : '-' }}
                    </div>
                    <div v-if="props.column.field == 'used'" class="flex justify-center">
                        {{ props.row.used }}
                    </div>
                    <div v-if="props.column.field == 'action'" class="flex justify-center capitalize">
                        <span class="text-red-400">{{ props.row.action }}</span>
                    </div>
                    <div v-if="props.column.field == 'status'" class="flex justify-center capitalize">
                        <span :class="getStatusColor(props.row.status)">{{ props.row.status }}</span>
                    </div>
                </template>

                <template #loadingContent>
                    <div class="w-full py-10 justify-center flex">
                        <Loader />
                    </div>
                </template>
            </vue-good-table>
            <!-- <button 
                v-if="isFilters"
                class=" cursor-pointer py-1 px-3 bg-gray-100 hover:bg-gray-200 rounded-md text-xs text-black flex justify-center items-center font-semibold absolute z-50 left-2" :class="isSelectionChanged ? 'top-14' : 'top-2' " @click="clearFilters">
                Clear filters
            </button> -->
        </div>
    </div>
</template>
<script>
    import {getCreditsAlloted} from "../../services"
    import Loader from "@/components/loader";
    import {FormatDate} from "@/plugins/functions"

    export default {
        name: "credit-packs",
        title: "Credit Admin",
        components: {
            Loader,
        },
        data() {
            return {
                columns: [  
                    { 
                        label: "Unique Id", 
                        field: "unique_id", 
                        filterOptions: {
                            enabled: true,
                        }, 
                    },
                    { 
                        label: "Assignee", 
                        field: "assignee",
                        filterOptions: {
                            enabled: true,
                        }, 
                    },
                    { 
                        label: "Limit/Month", 
                        field: "limits_per_month",
                        filterOptions: {
                            enabled: true,
                        }, 
                    },
                    { 
                        label: "Allocated", 
                        field: "alloted",
                        filterOptions: {
                            enabled: true,
                        }, 
                    },
                    { 
                        label: "Used", 
                        field: "used",
                        filterOptions: {
                            enabled: true,
                        }, 
                    },
                    { 
                        label: "Balance", 
                        field: "balance",
                        filterOptions: {
                            enabled: true,
                        }, 
                    },
                    { 
                        label: "Expiry Date", 
                        field: "expiry_date",
                        filterOptions: {
                            enabled: true,
                            filterFn: this.dateFilterFn
                        }, 
                    },
                    { 
                        label: "Status", 
                        field: "status",
                        filterOptions: {
                            enabled: true,
                        }, 
                    }, 
                ],
                rowsData: [],
                pageData: {
                    total_pages: 0,
                },
                currentPageData: {
                    page: 1,
                    count: 10,
                },
                loading: false,
                userLists: [],
                
            }
        },
        async mounted() {
            this.loading = true
            await this.setCreditPacks()
            this.loading = false

        },
        methods: {
            FormatDate,
            async setCreditPacks()
            {
                const qParams = `${this.$route.params.id}&page=${this.currentPageData.page}&limit=${this.currentPageData.count}`
                const {data} = await getCreditsAlloted(qParams)
                this.rowsData = data.credit_packs_alloted
                this.pageData = data?.pagination_info;
            },
            getStatusColor(status) {
                if (status.toLowerCase() == "in use") {
                    return "text-yellow-500"
                }
                if (status.toLowerCase() == 'active') {
                    return 'text-green-400'
                }
                if (status.toLowerCase() == 'expired') {
                    return 'text-red-400'
                }
            },
            async onPageChange(data, resetPage = false) {
                this.currentPageData = {
                    page: data.currentPage,
                    count: data.currentPerPage,
                };
                if (resetPage) this.currentPageData.page = 1;
                await this.setCreditPacks();
            },
            dateFilterFn(data, filterString) {
                let givenDate = FormatDate(new Date(data)).toLowerCase();
                return givenDate.includes(filterString.toLowerCase());
            }
        }

    }
</script>


